<template>
  <v-dialog v-model="modal" max-width="500px">
    <v-card v-if="modal">
      <v-card-title>
        <span class="headline">{{ $language('pages.projects.modals.remove.title') }}</span>
      </v-card-title>

      <v-card-text>
        <p>
          {{ $language('pages.projects.modals.remove.text') }}
        </p>
        <p class="v-label theme--light font-size-11px">
          ({{ project.Name }})
        </p>

        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          @click.native="close"
          color="info"
          flat
        >{{ $language('pages.projects.modals.remove.closeButton') }}</v-btn>

        <v-btn
          @click.native="remove"
          :disabled="$isLoading('remove')"
          :loading="$isLoading('remove')"
          color="error"
          flat
        >{{ $language('pages.projects.modals.remove.removeButton') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import loading from '@/mixin/loading';

export default {
  name: 'remove-project-modal',
  mixins: [loading],
  props: {
    project: { type: Object },
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      modal: this.value,
      errorMessage: '',
    };
  },
  methods: {
    async remove() {
      this.$startLoading('remove');
      try {
        await this.$api.projects.remove(this.project.ID);
        this.$emit('remove', this.project);
        this.close();
      } catch (err) {
        console.log(err);
        this.errorMessage = (err.response && err.response.data && err.response.data.message) || err.message;
        this.$store.commit('snackbar/show', this.errorMessage);
      }
      this.$stopLoading('remove');
    },
    close() {
      this.modal = false;
      this.$emit('input', false);
    },
    validateProjectProp() {
      if (this.modal
        && (!this.project
          || !this.project.ID
          || !this.project.Name)
      ) {
        throw new Error('Invalid prop: type check failed for prop "project". Expected Object');
      }
    },
  },
  watch: {
    value() {
      this.modal = this.value;
      this.validateProjectProp();
    },
    modal() {
      this.$emit('input', this.modal);
    },
    project() {
      this.validateProjectProp();
    },
  },
  created() {
    this.validateProjectProp();
  },
};
</script>

<style>
  .error-message {
    color: #FF5252;
  }
</style>
